@if (rendering && solarPanelsOrderFormViewModel; as vm) {
  <div>
    <wl-eplus-progressive-address-form
      [rendering]="rendering"
      [progressiveFormState]="vm.addressProgressiveFormState"
      [trackStep]="trackToolConfig.forStep('adres gegevens')"
    >
    </wl-eplus-progressive-address-form>
    <wl-eplus-progressive-personal-details-form
      [rendering]="rendering"
      [progressiveFormState]="vm.personalDetailsProgressiveFormState"
      [trackStep]="trackToolConfig.forStep('persoonlijke gegevens')"
    >
    </wl-eplus-progressive-personal-details-form>
    <wl-simple-progressive-form-card
      [progressiveFormState]="vm.confirmationProgressiveFormState"
      [content]="confirmationCardContent"
      [trackingConfig]="{
        toolName: confirmTrackStep.toolName,
        step: confirmTrackStep.step,
        stepName: confirmTrackStep.stepName,
      }"
      [asyncSubmission]="true"
      (submitted)="completeTool()"
    >
      <ng-template #content>
        @if (rendering.fields.ConfirmationDisclaimer?.value) {
          <wl-rich-text-wrapper
            [field]="rendering.fields.ConfirmationDisclaimer"
            ><p class="py-2"></p
          ></wl-rich-text-wrapper>
        }
        <div>
          @if (
            getControlByLabel(
              confirmationCheckboxes[0]?.fields?.Label?.value,
              vm.confirmationProgressiveFormState
            );
            as formControl
          ) {
            <wl-checkbox
              [formsControl]="formControl"
              [rendering]="{ componentName: confirmTrackStep.toolName }"
              [step]="confirmTrackStep.step"
              [stepName]="confirmTrackStep.stepName"
              [fieldName]="confirmationCheckboxes[0].fields.Label?.value"
              [tooltip]="confirmationCheckboxes[0].fields.Tooltip?.value"
              [hashValue]="confirmationCheckboxes[0].fields.HashValue?.value"
              [sendValue]="confirmationCheckboxes[0].fields.SendValue?.value"
              [showValidation]="true"
              class="mb-2"
            >
              <div *scText="confirmationCheckboxes[0].fields.Label"></div>
            </wl-checkbox>
          }

          @if (
            getControlByLabel(
              confirmationCheckboxes[1]?.fields?.Label?.value,
              vm.confirmationProgressiveFormState
            );
            as formControl
          ) {
            <wl-checkbox
              [formsControl]="formControl"
              [rendering]="{ componentName: confirmTrackStep.toolName }"
              [step]="confirmTrackStep.step"
              [stepName]="confirmTrackStep.stepName"
              [fieldName]="confirmationCheckboxes[1].fields.Label?.value"
              [tooltip]="confirmationCheckboxes[1].fields.Tooltip?.value"
              [hashValue]="confirmationCheckboxes[1].fields.HashValue?.value"
              [sendValue]="confirmationCheckboxes[1].fields.SendValue?.value"
              [showValidation]="true"
            >
              <div *scText="confirmationCheckboxes[1].fields.Label"></div>
            </wl-checkbox>
          }

          @if (
            rendering.fields['ConfirmationCheckboxAllowContactMoreInfoText']
              ?.value
          ) {
            <div class="more-info">
              @if (!showMoreInfo) {
                <button
                  class="btn btn-link"
                  (click)="this.showMoreInfo = true"
                  wlTrackLink
                  [trackLinkInfo]="{
                    rendering: rendering,
                    field: 'Meer informatie',
                    type: 'text',
                    eventType: 'button-click',
                  }"
                >
                  {{ moreInfoText }}
                </button>
              }
              @if (showMoreInfo) {
                <div>
                  {{
                    rendering.fields[
                      'ConfirmationCheckboxAllowContactMoreInfoText'
                    ]?.value
                  }}
                </div>
              }
            </div>
          }
        </div>
      </ng-template>
    </wl-simple-progressive-form-card>
  </div>
}
